import { render, staticRenderFns } from "./DrmEdit.vue?vue&type=template&id=52bf6981&"
import script from "./DrmEdit.vue?vue&type=script&lang=js&"
export * from "./DrmEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports